import { ThemeUIStyleObject } from 'theme-ui';

const cardBase = {
  maxWidth: ['25%', '5rem'],
  minWidth: '8rem',
  mr: '.5rem',
  p: '1rem 1rem',
  boxShadow: '0 0 0.5rem rgb(22 28 45 / 10%)',
  cursor: 'pointer',
  backgroundColor: '#FFF',
  fontFamily: 'Poppins',
  fontWeight: '400'
};

export const getDateSelectCalendarStyles = (
  height?: string | string[],
  cellFontSize?: string | string[],
  containerMarginTop?: string | string[],
  containerMarginBottom?: string | string[],
  containerMarginX?: string | string[],
  containerWidth?: string | string[],
): ThemeUIStyleObject => {
  return {
    '& .MuiDayPicker-monthContainer': {
      width: '100%',
      position: 'unset',
    },
    '& .MuiCalendarPicker-viewTransitionContainer': {
      //height: '70%',
    },
    '& .MuiMonthPicker-root': {
      mx: 0
    },
    '.MuiPickersDay-today': {
      border: 'none !important',
    },
    '& > div': {
      position: 'relative',
      p: 0,
      textAlign: 'center',
    },
    '& > div:first-child': {
      marginTop: containerMarginTop || ['6px', '20px'],
      marginBottom: containerMarginBottom || [0, '10px'],
      mx: containerMarginX,
      width: containerWidth,
    },
    '& > div:nth-child(2) > div': {
      minHeight: 'unset !important',
    },
    '& > div div[role="presentation"]': {
      display: 'flex',
      justifyContent: 'center',
      //position: 'absolute',
      width: '100%',
      mx: 'auto',
      fontSize: ['16px', '20px', '20px'],
      fontFamily: '"Proxima Nova", sans-serif'
    },
    '& > div div[role="presentation"] > .MuiButtonBase-root': {
      display: 'none'
    },
    '& .MuiPickersArrowSwitcher-root': {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      width: '95%',
    },
    '& .MuiTypography-root': {
      width: 'calc(1/7 * 100%) !important'
    },
    '.MuiCalendarPicker-root .MuiTypography-root': {
      width: 'calc(1/7 * 100%) !important'
    },
    // eslint-disable-next-line max-len
    '& div[role="rowgroup"] > div[role="cell"]': {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
    '& div[role="rowgroup"] > div[role="row"] > *': {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: '14.5% !important',
      marginBottom: '0',
      marginTop: ['0', '10px'],
      height: height || ['12vw', '12vw', '44px', '64px'],
      fontSize: cellFontSize,
    },
    '& div[role="grid"] > div[role="presentation"]': {
      height: '100%',
    },
    '& .Mui-disabled[role="gridcell"]': {
      color: 'lightgray',
    },
    '& button.Mui-selected.MuiPickersDay-dayWithMargin': {
      backgroundColor: 'transparent',
      backgroundImage: 'url(/calendar-selected-date-circle.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    '& button.MuiButtonBase-root.MuiPickersDay-dayWithMargin': {
      backgroundColor: 'transparent',
    },
    '& button.MuiButtonBase-root.MuiPickersDay-dayWithMargin > .MuiTouchRipple-root': {
      display: 'none',
    },
  };
};

const style: Record<string, ThemeUIStyleObject> = {
  card: {
    ...cardBase,
  },
  selectedCard: {
    ...cardBase,
    backgroundColor: '#E9E8F6',
    '& h4': {
      color: 'white',
    },
    fontWeight: 'bold'
  },
  chevron: {
    width: '1rem',
    height: '2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '30px',
  },
  heading: {
    fontFamily: 'Poppins;',
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '35px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#000000',
  },
  dateInputContainer: {
    backgroundColor: '#fff',
    boxShadow: '0px 1px 21px -2px rgba(0, 0, 0, 0.07)',
    borderRadius: '12px',
    width: '100%',
    justifyContent: 'space-between',
    mr: '20px',
    height: '55px'
  },
  inputPlaceholder: {
    p: '1rem 2rem',
    color: '#273443',
    fontFamily: 'Inter',
    fontWeight: '400',
    lineHeight: '19px',
    fontSize: '16px',
    letterSpacing: '0em',
    textAlign: 'left',
    cursor: 'pointer',
    width: '90%',
  },
};

export default style;

